import Swiper, { Scrollbar, Navigation, Pagination, Autoplay } from 'swiper'
Swiper.use([ Scrollbar, Navigation, Pagination, Autoplay])

const breakpoints = {
  420: {
    spaceBetween: 20
  },
  576: {
    spaceBetween: 30
  },
  1024: {
    spaceBetween: 40
  }
}
const breakpoint = window.matchMedia('(min-width: 768px)')

export const initProductSlider = () => {
  const swipers = [];

  const breakpointChecker = function(){
    if(breakpoint.matches){
      swipers.forEach(swiper => swiper.destroy( true, true ))
      swipers.length = 0;
      return
    } else {
      return enableSwipers()
    }
  }

  const enableSwipers = function(){
    document.querySelectorAll('.slider--products')
      .forEach(el => {
        let scrollbarEl = el.querySelector('.swiper-scrollbar')
        let scrollbarOption = {}
        if(scrollbarEl){
          scrollbarOption = {
            scrollbar: {
              el: scrollbarEl,
              draggable: true,
            }
          }
        }
        let options = {
          slidesPerView: 'auto',
          spaceBetween: 16,
          breakpoints: {
            769: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
          },
          ...scrollbarOption
        }
        swipers.push(new Swiper(el, options))
      })
  }

  breakpoint.addEventListener("change", breakpointChecker)
  breakpointChecker();
}

export const initCardSlider = () => {
  const swipers = [];

  const breakpointChecker = function(){
    if(breakpoint.matches){
      swipers.forEach(swiper => swiper.destroy( true, true ))
      swipers.length = 0;
      return
    } else {
      return enableSwipers()
    }
  }

  const enableSwipers = function(){
    document.querySelectorAll('.slider--cards')
      .forEach(el => {
        let scrollbarEl = el.querySelector('.swiper-scrollbar')
        let scrollbarOption = {}
        if(scrollbarEl){
          scrollbarOption = {
            scrollbar: {
              el: scrollbarEl,
              draggable: true,
            }
          }
        }
        let options = {
          slidesPerView: 'auto',
          spaceBetween: 16,
          breakpoints: {
            769: {
              spaceBetween: 24,
            },
          },
          ...scrollbarOption
        }
        swipers.push(new Swiper(el, options))
      })
  }

  breakpoint.addEventListener("change", breakpointChecker)
  breakpointChecker();
}

export const initImageSlider = () => {

  document.querySelectorAll('.slider--images')
    .forEach(el => {
      let autoplay = el.classList.contains('slider--autoplay');
      let speed = el.dataset.speed;
      let startOnScroll = el.dataset.startOnScroll;
      let pagination = el.querySelectorAll('.swiper-pagination');
      let autoplayOption = {};
      let paginationOption = {};

      //pagination
      if(pagination.length){
        let paginationType = pagination[0].dataset.paginationType;
        if(paginationType){
          let navigation = paginationType == 'fraction' ? {
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }
          } : '';
          paginationOption = {
            pagination: {
              el: ".swiper-pagination",
              type: paginationType,
              clickable: true
            },
            ...navigation
          }
        }
      }
      
      //autoplay
      if(autoplay) {
        let s = speed && !isNaN(speed) ? speed * 1000 : 3000;
        autoplayOption = {
          autoplay: {
            delay: s < 500 ? 500 : ( s > 10000 ? 10000 : s)
          },
          loop: true,
        }
      }

      //slider options
      let options = {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        speed: 800,
        breakpoints: breakpoints,
        ...autoplayOption,
        ...paginationOption
      }
    
      //shuffling
      if( el.classList.contains('slider--shuffled') ){
        let slide_wrapper = el.querySelector('.swiper-wrapper');
        for (var i = slide_wrapper.children.length; i >= 0; i--) {
          slide_wrapper.appendChild(slide_wrapper.children[Math.random() * i | 0]);
        }
      }

      const swiper = new Swiper(el, options);

      if(autoplay && startOnScroll) {
        swiper.autoplay.stop();

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if(entry.isIntersecting && !swiper.autoplay.running) {
              swiper.autoplay.start()
            }
          });
        }, { threshold: 0.2 })

        observer.observe(el)
      }
    })
}
